// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Xqrz","header":"ReportDetails_header__3tc8z","title":"ReportDetails_title__2P7Gv","left":"ReportDetails_left__3nVaI"};